// eslint-disable-next-line
/* eslint-disable  @typescript-eslint/no-explicit-any, @angular-eslint/directive-selector, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/explicit-module-boundary-types */
import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
	// eslint-disable-next-line
	selector: '[epiRadioControl]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => EpiRadioControlDirective),
			multi: true,
		},
	],
})
export class EpiRadioControlDirective implements ControlValueAccessor {

	public innerValue!: any;
	public disabled: boolean = false;
	public checked: boolean = false;

	constructor(
		private readonly el: ElementRef<HTMLEpiRadioElement>,
		private readonly renderer: Renderer2,
	) { }

	@HostListener('epiCheckChanged', ['$event'])
	public handleChange(ev: CustomEvent): void {
		this.value = (<HTMLEpiRadioElement>ev.target).value;
	}

	onChange: any = () => { };
	onTouched: any = () => { };

	public get value(): any {
		return this.innerValue;
	}

	public set value(val: any) {
		this.innerValue = val;
		this.onChange(val);
	}

	/** Handles the value being updated for the form control */
	writeValue(value: string): void {
		this.value = value;
		if (value === this.el.nativeElement.value) {
			this.renderer.setProperty(
				this.el.nativeElement,
				'checked',
				true,
			);
		}
	}

	/** Handles the change of the control's value */
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	/** Handles when the cnotrol has been touched */
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	/** Sets the disabled state of the control */
	setDisabledState(isDisabled: boolean): void {
		this.renderer.setAttribute(
			this.el.nativeElement,
			'disabled',
			`${isDisabled}`,
		);
	}

}
